import styled from 'styled-components';

const Wrapper = styled.div`
  .companyName {
  }
`;

export default Wrapper;
